// Fix hover menu issues - ensure submenu works consistently
function initializeHoverFix() {
  const menuItems = document.querySelectorAll('.x-menu--level-1--link');
  
  if (menuItems.length === 0) {
    // If menu items aren't loaded yet, try again in a moment
    setTimeout(initializeHoverFix, 100);
    return;
  }
  
  menuItems.forEach(item => {
    const submenu = item.querySelector('.x-menu--level-2--container');
    if (!submenu) return;
    
    // Remove any existing event listeners to prevent conflicts
    const newItem = item.cloneNode(true);
    item.parentNode.replaceChild(newItem, item);
    
    const newSubmenu = newItem.querySelector('.x-menu--level-2--container');
    
    // Add mouse enter event
    newItem.addEventListener('mouseenter', function() {
      newSubmenu.style.display = 'block';
      newSubmenu.style.visibility = 'visible';
      newSubmenu.style.opacity = '1';
      newSubmenu.style.zIndex = '1000';
      newSubmenu.style.height = 'auto';
      // Remove any transition states that might hide the submenu
      newSubmenu.removeAttribute('data-transition');
    });
    
    // Add mouse leave event
    newItem.addEventListener('mouseleave', function() {
      newSubmenu.style.display = 'none';
      newSubmenu.style.visibility = 'hidden';
      newSubmenu.style.opacity = '0';
      newSubmenu.style.height = '0';
    });
  });
  
  console.log('Hover fix applied to', menuItems.length, 'menu items');
}

// Try to initialize immediately
initializeHoverFix();

// Also try when DOM is ready
document.addEventListener('DOMContentLoaded', initializeHoverFix);

// And try when window loads
window.addEventListener('load', initializeHoverFix); 